import { PortalItineraryStatus } from "@b2bportal/air-booking-api";

export const StatusCopyKeyMap: Record<PortalItineraryStatus, string> = {
  [PortalItineraryStatus.Canceled]: "core-flights.itinerary.status.canceled",
  [PortalItineraryStatus.Confirmed]: "core-flights.itinerary.status.confirmed",
  [PortalItineraryStatus.Modified]: "core-flights.itinerary.status.modified",
  [PortalItineraryStatus.Pending]: "core-flights.itinerary.status.pending",
};
